"use client";
import useElementId from "../../hooks/useElementId.js";
import React from "react";
import { classNames } from "../../utilities/helpers.js";
import AccordionContext from "./Accordion.context.js";
const AccordionControlled = (props) => {
    const { children, onToggle, active, iconPosition, iconSize, className, attributes } = props;
    const rootClassNames = classNames(className);
    const id = useElementId();
    const value = React.useMemo(() => ({
        triggerId: `${id}-trigger`,
        contentId: `${id}-content`,
        active,
        onToggle,
        iconPosition,
        iconSize,
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [active]);
    return (React.createElement("div", { ...attributes, className: rootClassNames },
        React.createElement(AccordionContext.Provider, { value: value }, children)));
};
export default AccordionControlled;
